import { connect, MapStateToProps } from 'react-redux';
import { Props } from './Head';
import { getFlags } from '@wix/da-react-context/pkg/flags/redux/selectors';
import {
  getThemeSkin,
  getPageThumb,
  getSeoCanonical,
  getIsMobile,
  getSeoTitle,
  getSeoDescription,
  getSeoPrevUrl,
  getSeoNextUrl,
  getSeoRating,
  getIsIOS,
} from '../../publicSession/selectors';
import { getChatNewMessageArrived } from '../../Chat/redux/selectors';

export type StateProps = Pick<
  Props,
  | 'flags'
  | 'themeSkin'
  | 'pageThumb'
  | 'pageUrl'
  | 'isMobile'
  | 'isIOS'
  | 'pageTitle'
  | 'pageDescription'
  | 'pageRating'
  | 'hasNewChatMessage'
  | 'prevUrl'
  | 'nextUrl'
>;
export type OwnProps = Omit<Props, keyof Omit<StateProps, 'themeSkin'>>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (
  state,
  ownProps
) => ({
  flags: getFlags(state),
  isMobile: getIsMobile(state),
  isIOS: getIsIOS(state),
  themeSkin: ownProps.themeSkin || getThemeSkin(state),
  pageThumb: getPageThumb(state),
  pageUrl: getSeoCanonical(state),
  pageTitle: getSeoTitle(state),
  pageDescription: getSeoDescription(state),
  pageRating: getSeoRating(state),
  hasNewChatMessage: getChatNewMessageArrived(state),
  prevUrl: getSeoPrevUrl(state),
  nextUrl: getSeoNextUrl(state),
});

export default connect(mapStateToProps);
